"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var AlertTitleTheme = function AlertTitleTheme() {
  return {
    defaultProps: {
      variant: 'h5'
    },
    styleOverrides: {
      root: {
        width: '100%',
        marginBottom: '12px',
        marginTop: 0,
        paddingLeft: '32px',
        paddingRight: '32px'
      }
    }
  };
};

var _default = AlertTitleTheme;
exports["default"] = _default;